export enum UserTypes {
    user = 1,
    admin = 100,
}
